<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.19336 3.92773H17.4698C18.0221 3.92773 18.4698 4.37545 18.4698 4.92773V17.8424" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M14.2633 7.08496H6.53027C5.97799 7.08496 5.53027 7.53268 5.53027 8.08496V19.072C5.53027 19.6243 5.97799 20.072 6.53027 20.072H14.2633C14.8156 20.072 15.2633 19.6243 15.2633 19.072V8.08496C15.2633 7.53268 14.8156 7.08496 14.2633 7.08496Z" stroke="currentColor" stroke-width="1.5"/>
    </svg>
</template>
